import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PercentGraphic extends UcoastEl {
	static htmlSelector = 'percent-graphic'
	percentValue: number
	animateElement: HTMLElement

	constructor() {
		super()
		this.percentValue = parseInt(q.ra(this, 'data-uc-percent-graphic'))
		this.animateSelf = true
		this.animateElement = q.os('[data-uc-percent-inner]', this) ?? this
	}

	override animateIn() {
		super.animateIn()
		window.setTimeout(() => {
			// used to be 25 now it's 15
			this.animatePercentGraphic(0, this.percentValue, 15 * this.percentValue)
		}, 5)
	}
	override animateOut() {
		super.animateOut()
		this.animateElement.style.setProperty('--p', `0`)
	}

	animatePercentGraphic(start: number, end: number, duration: number) {
		let current = start
		const stepTime = 16.67 // 60fps

		const step = () => {
			current += ((end - start) * stepTime) / duration
			if (current > end) {
				current = end
			}

			this.animateElement.style.setProperty('--p', `${current}`)

			if (current < end) {
				requestAnimationFrame(step)
			}
		}

		requestAnimationFrame(step)
	}
}
